// TODO make locale configurable - see src/lib/providers/AntdConfigProvider.tsx
export const DEFAULT_LOCALE = "cs-CZ";

// Simple cache keyed by locale + options to avoid re-creating formatters
const formatterCache = new Map<string, Intl.NumberFormat>();

const getFormatter = (locale: string, options?: Intl.NumberFormatOptions) => {
    const key = `${locale}|${JSON.stringify(options || {})}`;
    let nf = formatterCache.get(key);
    if (!nf) {
        nf = new Intl.NumberFormat(locale, options);
        formatterCache.set(key, nf);
    }
    return nf;
};

const getDecimalPlaces = (num: number): number => {
    const str = String(num);
    const decimalIndex = str.indexOf(".");
    if (decimalIndex === -1) return 0;
    return str.length - decimalIndex - 1;
};

// NOTE: keep params optional to let callers omit locale
// Preserves original decimal places from backend - no rounding on FE
export const formatNumber = (amount: number, locale?: string): string => {
    const fractionDigits = getDecimalPlaces(amount);
    const options: Intl.NumberFormatOptions = {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    };
    return getFormatter(locale ?? DEFAULT_LOCALE, options).format(amount);
};
